@if (isMenu) {
  <button mat-menu-item>
    <mat-icon>restore_outline</mat-icon>
    {{ 'restore' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'restore' | translate"
    matTooltip="{{ 'restore' | translate }}">
    <mat-icon>restore_outline</mat-icon>
  </button>
}
